import React from 'react';
import { Card, Button, Typography, Space, Divider } from 'antd';
import { GoogleOutlined } from '@ant-design/icons';
import { useAuth } from '../hooks/useAuth';

const { Title, Text } = Typography;

const LoginPage = () => {
  const { login, loading } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          borderRadius: '12px'
        }}
        bodyStyle={{ padding: '40px 30px' }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={2} style={{ color: '#1890ff', marginBottom: '8px' }}>
              COGS Management
            </Title>
            <Text type="secondary" style={{ fontSize: '16px' }}>
              Xendit Cost of Goods Sold Management System
            </Text>
          </div>

          <Divider />

          <div>
            <Title level={4} style={{ marginBottom: '16px' }}>
              Welcome Back
            </Title>
            <Text type="secondary">
              Sign in with your Xendit Google account to continue
            </Text>
          </div>

          <Button
            type="primary"
            size="large"
            icon={<GoogleOutlined />}
            onClick={login}
            loading={loading}
            style={{
              width: '100%',
              height: '48px',
              fontSize: '16px',
              borderRadius: '8px'
            }}
          >
            Sign in with Google
          </Button>

          <div style={{ marginTop: '24px' }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              By signing in, you agree to our terms of service and privacy policy.
              <br />
              Only authorized Xendit employees can access this system.
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default LoginPage;
